if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.cartPage = document.querySelector('.shopify-section.cc-main-cart');
        this.submitBtn = this.querySelector('[name="add"]');
        this.quickAddChange = null;

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      
      evt.preventDefault();

      // js-disabled class is used on PDP for
      // commercial charger products
      // because quick view enabled for these products
      if(this.submitBtn.classList.contains('js-disabled')) return;
      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      if(this.classList.contains('js-add-change-form')){
        this.quickAddChange = true;
      }

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      let oldQuantitys, newQuantitys;

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        oldQuantitys = oldCartData && this.getVariantsWithQuantity(oldCartData)

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();

        if (data.status) this.setErrorMsgState(data.description);

        // if (!response.ok) throw new Error(response.status);
        if (!response.ok) this.handleError(data, response);
        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
              // Update cart drawer only when change button selected
              if(this.quickAddChange){
                const cartItems = document.querySelector('cart-items');
                if (cartItems) cartItems.refreshCart({
                  index: this.dataset.index, key: this.dataset.key
                });
              }

              this.cartDrawer.successfullyAdded(100);
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) cartItems.refreshCart({ 
                index: this.dataset.index, key: this.dataset.key
              });
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();

        newQuantitys = newCartData && this.getVariantsWithQuantity(newCartData);

        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        if (this.cartDrawer) {
          if(this.quickAddChange){
            const cartItems = document.querySelector('cart-items');
            if (cartItems) cartItems.refreshCart();
          }
        }
        console.log('catch (error):', error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);


        if(oldQuantitys && newQuantitys){
          const updatedItems = {};
          let updates = false;

          // Check for updated items
          Object.entries(newQuantitys).forEach(([key, value]) => {
            // Check for updated quantitys
            if(oldQuantitys[key] != undefined && oldQuantitys[key].qty != value.qty){
              console.warn(`${key} quantity ${oldQuantitys[key].qty} has changed to ${value.qty}`);

              if(oldQuantitys[key].qty > value.qty){
                updates = true;
                updatedItems[key] = {
                  from: oldQuantitys[key].qty,
                  to: value.qty,
                  variant: value.variant,
                  key: value.variant.key
                }
              }
            }
            // Check for updated prices
            const priceWhenAdded = value.variant?.properties['_priceWhenAdded'];
            if(priceWhenAdded){
              if(priceWhenAdded != value.variant.price) {
                updates = true;

                updatedItems[key] = {
                  ...updatedItems[key],
                  priceFrom: parseInt(priceWhenAdded),
                  priceTo: value.variant.price,
                  variant: value.variant,
                  key: value.variant.key
                }
              }
            }
          });

          // Check for deleted items
          Object.entries(oldQuantitys).forEach(([key, value]) => {
            if(newQuantitys[key] == undefined){
              console.warn(`${key} quantity ${oldQuantitys[key]} was deleted`)
              updates = true;

              updatedItems[key] = {
                from: value,
                to: 0,
                variant: value.variant,
                key: value.variant.key
              }
            }
          });
          updates && localStorage.setItem('item_updates', JSON.stringify(updatedItems))
        }
      }
    }


    /**
     * Get items quantity from old and new cart
     * to compare if quantity was updated automatically
     * @param {object} cart - cart object
     * @returns {?object} - [item.id]: quantity
     */
    getVariantsWithQuantity(cart){
      if(!cart) return null
      const items = {};

      cart.items.forEach(item => {
        items[item.id] = {
          qty: item.quantity,
          variant: item
        };
      });

      return items;
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    getProductData(el) {
      if(!el) return null
      const dataEl = el.querySelector('#product-data[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    handleError(error, response){
      if(this.closest('.js-product')){
        // const quickAdd = this.closest('quick-add-drawer');
        const quickAdd = this.closest('.js-product');
        const variantPicker = quickAdd && quickAdd.querySelector('variant-picker');

        this.data = variantPicker && this.getProductData(variantPicker);
        this.data && (this.product = this.data.product);
      }

      let $err = error.description;
      if(this.data && error.description && error.description.includes('[[quantity_available]]')){
        let $variants = this.product.variants;
        let $productId = this.product.id;

        $err = error.description.split('variant-')[0];

        let $variantTitle = error.description.split('variant-')[1];
        let $variant = null;
  
        if($variantTitle){
          $variants.forEach(v => {
            if($variantTitle == v.name){
              $variant = v.id;
            }
          })
        }
  
        const relatedProd = document.querySelector(`[data-inventory-${$productId}]`)?.dataset; 
        if(relatedProd){
          const variantCount = relatedProd[`variantInventory-${$variant}`];
          // const firstVariantCount = relatedProd[`firstAvailableVariantQuantity`];
          
          if(variantCount){
            $err = $err.replace('[[quantity_available]]', variantCount);
          } 
          
          this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');

          if (!this.errorMsg) return;

          this.errorMsg.hidden = !error;
          this.errorMsg.textContent = $err;
        } else {
          $err = $err.replace('[[quantity_available]]', 'count');

          this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
          if (!this.errorMsg) return;

          this.errorMsg.hidden = !error;
          this.errorMsg.textContent = $err;
        }
      } else {
        throw new Error(error.description || response.status);
      }
      throw new Error(error.description || response.status);
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }
  }

  customElements.define('product-form', ProductForm);
}
